<template>
  <p-autocomplete
    :minLength="1"
    :selectOnFocus="true"
    :suggestions="filter"
    ref="field"
    v-model="value"
  />
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import AutoComplete from 'openvue/autocomplete';

type GridDataFilterParams = {
  options: object[];
  key: string;
  value?: string | null;
};

export default defineComponent({
  components: {
    'p-autocomplete': AutoComplete,
  },
  props: {
    params: {
      type: Object as PropType<GridDataFilterParams>,
      default: () => ({ options: [], key: '' }),
    }
  },
  data() {
    return {
      value: null as string | null,
      suggestions: this.params.options
        .map(option => (option as Record<string, unknown>)[this.params.key])
        .filter((option): option is string => typeof option === 'string'),
    };
  },
  computed: {
    filter(): string[] {
      const value = this.value;
      if (!value) { return []; }
      return this.suggestions.filter(option => option.includes(value.toUpperCase())).slice(0, 100);
    }
  },
  mounted() {
    this.value = this.params.value ?? null;
  },
  methods: {
    getValue() {
      return this.value?.toUpperCase();
    },
  },
});
</script>
<style lang="scss">
.ag-popup-editor {
 .p-autocomplete-input.p-inputtext {
    padding: 0.53125rem;
    color: inherit;
    border: 0;
    box-shadow: none;
  }
}

</style>
